<template>
  <div>
    <a-form @submit="submit" :data="data" ref="form" :form="form">
      <a-row class="form-row">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="活动标题">
            <a-input :read-only="true" placeholder="请输入活动标题" v-decorator="[
              'title',
              {initialValue:data.title,rules: [{ required: false, message: '请输入活动标题' }]}]"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label=" 注销时间">
            <a-date-picker :disabledDate="disabledDate" showTime format="YYYY-MM-DD HH:mm:ss" v-decorator="[
          'cancelTime',
          {initialValue:data.cancelTime,rules: [{ required: true, message: '请选择注销时间' }]}]" />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <div class="hp-manager-dialog-footer">
      <a-form-item label>
        <a-button type="primary" @click="submit" :loading="loading">确认</a-button>
        <a-button style="margin-left:10px" @click="cancel">取消</a-button>
      </a-form-item>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { api, exzends, rules } from "@/common";
import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import config from "@/config";
import { constants } from "zlib";
import { fail } from "assert";
const defaultData = {
  id: 0,
  title: "",
  cancelTime: null
};
export default {
  name: "hp-manager-page-PromotionActivity-cancel",
  mixins: [account, dateFormat],
  // 接受属性
  props: {
    paramsX: Object
  },
  data() {
    return {
      loading: false,
      data: {},
      form: this.$form.createForm(this),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      startTime: null,
      endTime: null
    };
  },
  async mounted() {
    this.getdetailPromotionActivity();
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    disabledDate(current) {
      return (
        current &&
        (current <= this.startTime.startOf("day") ||
          current > this.endTime.startOf("day"))
      );
    },
    async getdetailPromotionActivity() {
      this.loading = true;
      let result = await api.GetPromotionActivity({
        id: this.paramsX.id
      });

      if (result) {
        this.data = result;
        this.endTime = new moment(this.data.endTime);
        this.startTime = new moment(this.data.startTime);
        this.data.cancelTime =
          this.startTime < new moment()
            ? new moment()
            : new moment(this.data.startTime);
      }
      this.loading = false;
    },
    dataToPostData(value) {
      let result = {
        id: this.data.id,
        cancelTime: value.cancelTime.valueOf()
      };
      return result;
    },

    async submit() {
      this.loading = true;
      let valid = await new Promise((resolve, reject) => {
        this.form.validateFields((err, values) => {
          resolve({
            err,
            values,
            field: err ? "" : Object.keys(values)[0]
          });
        });
      });
      if (!valid.err) {
        let requestData = this.dataToPostData(valid.values);
        let data = await api.CancelPromotionActivity(requestData);
        if (data) {
          this.$message.success("注销成功");
          this.$emit("submit-success");
        }
      }
      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
@import "../../../assets/scss/output.scss";
</style>


// WEBPACK FOOTER //
// src/router/Promotions/Activity/CancelConfirm.vue